let keyupTimer = 0;

/**
 * função que faz request no evento informado no data request, a busca dos dados
 * é feita com like %text%, ou seja, busca tudo que tiver as letras digitadas
 * no nome
 *
 * para utilizar basta setar uma data-request-selectize e indicar qual event
 * será utilizado ex: data-request-selectize => focus.
 * e um data-url com a rota que receberá a requisição no selectize,
 * ou enviar o selectize como parametro
 */

/**
 * Função de inicialização
 *
 * @param inputSelectize
 */
function makeRequest(inputSelectize = null) {
  // se não for null quer dizer que outro js está enviando o selectize
  // então não precisamos buscar na view
  if (inputSelectize === null) {
    const inputSelectize = document.querySelectorAll('[data-request-selectize]');
    inputSelectize.forEach((element) => {
      const $selectize = $(element)[0].selectize;
      const groupedOptions = element.dataset.groupedOptions === 'true';
      addEvent(
        $selectize,
        element.dataset.url,
        element.dataset.requestSelectize,
        groupedOptions
      );
    });
  } else {
    addEvent(inputSelectize, inputSelectize.$input.data('url'), 'focus');
  }
}

/**
 * adiciona o evento de keyup nos selectize
 *
 * @param $selectize
 * @param url
 */
function addEvent($selectize, url, event, groupedOptions) {
  const $input = $selectize.$control.find('input')
  $input.attr('data-url', url);
  const func = event + 'Event';
  $input.on(event, (e) => {
    window[func](e.target, handlerSelectize, $selectize, groupedOptions);
  })
}

/**
 * seta timeout para o envento de keyup
 *
 * @param input
 * @param callback
 */
window.keyupEvent = function (input, callback, $selectize, groupedOptions) {
  clearTimeout(keyupTimer);
  keyupTimer = setTimeout(function () {
    callback(input.dataset.url, input.value, $selectize);
  }, 500);
}

/**
 * dispara uma request para buscar tudo sobre o campo que foi dado foco
 *
 * @param input
 * @param $selectize
 */
window.focusEvent = function (input, callback, $selectize, groupedOptions) {
  const url = input.dataset.url;
  callback(url, null, $selectize, groupedOptions);
}

/**
 * faz a requisição para buscar os dados a ser adicionado no selectize
 *
 * @param input
 */
function handlerSelectize(url, value, $selectize, groupedOptions) {
  sendRequest(url, value)
    .done((data) => {
      addOptionsSelectize(data.data, $selectize, groupedOptions);
    })
}

/**
 * remove as opções do selectize e adiciona as novas
 *
 * @param moedas
 * @param $selectize
 * @param value
 */
function addOptionsSelectize(moedas, $selectize, groupedOptions = false) {
  // limpa as opções do selectize
  $selectize.clearOptions();
  // percorre o resultado da requisição e adiciona no selectize
  if (groupedOptions) {
    Object.entries(moedas).forEach((moeda) => {
      $selectize.addOptionGroup(moeda[0], {
        label : moeda[0]
      });
      for (const id in moeda[1]) {
        $selectize.addOption({
          value: id,
          text: moeda[1][id],
          optgroup: moeda[0]
        });
      }
    });
  } else {
    for (const id in moedas) {
      $selectize.addOption({
        value: id,
        text: moedas[id]
      })
    }
  }
  $selectize.open();
}

/**
 * Faz a requisição para obtenção do dados
 *
 * @param url
 */
function sendRequest(url, name) {
  return $.ajax({
    method: 'GET',
    url: url,
    data: {'name': name}
  });
}

exports.init = makeRequest;
